import { useSupportPreview } from '@/context/SupportPreviewContext';
import { Shield } from 'lucide-react';

/**
 * Sticky banner shown when admin views producer portal in support preview mode.
 * Clearly communicates read-only state.
 */
export function SupportPreviewBanner() {
  const { isSupportPreview } = useSupportPreview();

  if (!isSupportPreview) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-50 flex items-center gap-2 px-4 py-2.5 text-sm border-b border-amber-300/40 bg-amber-50 text-amber-900 dark:bg-amber-950/60 dark:text-amber-200 dark:border-amber-700/40"
    >
      <Shield className="h-4 w-4 shrink-0" />
      <span className="font-medium">Supportläge</span>
      <span className="hidden sm:inline text-amber-700 dark:text-amber-300">
        — Du tittar på värdportalen som admin. Ändringar är avstängda.
      </span>
    </div>
  );
}
